/**
 * Centralized Design System Tokens & WCAG 2.1 AA Theme Constants
 * Single source of truth for colors, typography, focus indicators, and dark mode classes.
 */

export const BRAND_COLORS = {
  primary: "#037a6a",
  primaryHover: "#025f52",
  primaryLight: "#effefc",
  primaryDark: "#01473d",
  accent: "#ff6b6b",
  neutral: {
    50: "#fafaf9",
    100: "#f5f5f4",
    200: "#e7e5e4",
    300: "#d6d3d1",
    400: "#a8a29e",
    500: "#78716c",
    600: "#57534e",
    700: "#44403c",
    800: "#292524",
    900: "#1c1917",
    950: "#0c0a09",
  },
} as const;

export const THEME_TOKENS = {
  colors: BRAND_COLORS,
  classes: {
    // Brand Backgrounds
    primaryBg: "bg-[#037a6a]",
    primaryHoverBg: "hover:bg-[#025f52]",
    primaryActiveBg: "active:bg-[#01473d]",
    activeItemBg: "bg-[#effefc] dark:bg-[#037a6a]/20",

    // Brand Text
    primaryText: "text-[#037a6a] dark:text-[#2dd4bf]",
    primaryHoverText: "hover:text-[#025f52] dark:hover:text-[#5eead4]",
    bodyText: "text-stone-700 dark:text-stone-200",
    mutedText: "text-stone-500 dark:text-stone-400",
    headingText: "text-stone-900 dark:text-stone-50",

    // Borders
    primaryBorder: "border-[#037a6a]",
    subtleBorder: "border-stone-200 dark:border-stone-800",

    // Accessibility Focus Rings (WCAG 2.1 AA)
    focusRing:
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#037a6a] focus-visible:ring-offset-2 dark:focus-visible:ring-offset-stone-900",

    // Shadow & Elevation
    shadowPrimary: "shadow-md shadow-[#037a6a]/20",
    
    // Motion Accessibility
    motionSafe: "motion-reduce:transition-none motion-reduce:transform-none",
  },
} as const;
